<template>
  <div class="content">
    <arrorImg bg="white"></arrorImg>
    <navBar title="最近阅读" color="#ffffff"></navBar>
    <div class="content-box">
      <div v-if="!isEmpty">
		  <ul
  v-infinite-scroll="loadMore"
  :infinite-scroll-disabled="loading"
  infinite-scroll-distance="10">
        <li
          v-for="(item, index) in lastList"
          :key="index"
          class="list-item"
          @click="routeRead(item)"
        >
          <img class="cover-book" :src="item.bookLogoUrl" alt="" />
          <div>
            <span class="book-name">{{ item.bookName }}</span>
            <span class="book-author"
              >{{ item.bookAuthor }}
              {{ item.bookFinish === 0 ? "完结" : "连载" }}
            </span>
            <span class="book-order"
              >读至 第{{ item.chapterOrders }}章 {{ item.chapterName }}</span
            >
            <span class="book-time">{{ item.lastReadTime }}</span>
          </div>
		  </li>
		  </ul>
		   <div class="load-more">
          <span>{{ !isLoading ?'加载中':loadText }}</span>
        </div>
        </div>
      <div v-else class="no-log" >
        <img class="empty-img" src="../../../static/no-log.png" alt="" />
        <span class="tips-no">暂无内容</span>
      </div>
    </div> 
    <qCode
      :qcodeUrl="qcodeUrl"
      :isShowQcode="isShowQcode"
      @eventChange="eventChange"
    ></qCode>
    <buyBook
      :showBuyMask="showBuyMask"
      :countCurrency="countCurrency"
      @buyChange="buyChange"
      :userCurrency="userCurrency"
    ></buyBook>
  </div>
</template>

<script>
import { Toast, MessageBox,InfiniteScroll  } from "mint-ui";
// Vue.use(InfiniteScroll);
import arrorImg from "../../components/arrow-img.vue";
import qCode from "../bookRead/component/qcode.vue";
import navBar from "../components/navbar.vue";
import buyBook from "../components/buyBook.vue";
export default {
  components: {
    arrorImg,
    qCode,
    navBar,
    buyBook,
  },
  data() {
    return {
		loading:false,
      countCurrency: 0, //整本书币，
      showBuyMask: false, //显示整本订购弹窗
      userCurrency: 0, //用户剩余书币
      purchaseWholeBook: 0,
      item: {},
      isEmpty: false,
      pageNo: 1,
      pageSize: 10,
      pageCount: 1,
      lastList: [],
      loadText: "",
      CountPage: 1,
      qcodeUrl: "",
      isShowQcode: false,
      isEntranceData: "",
      isReload: false,
      isLoading:false,
      pageType:''
    };
  },
  onShow() {
    // let pages = getCurrentPages(); // 获取当前打开过的页面路由数组
    // var currPage = pages[pages.length - 1]; //当前页面
    // if (currPage.isReload) {
    // 	this.pageNo=1;
    // 	this.loadText = '加载中...';
    // 	this.findReadBookByMonth();
    // }
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    this.pageType= this.$route.query.pageType;
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    	 var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (isWxAuthorized==0&&city==1 && openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.findReadBookByMonth();
    } else {
      this.findReadBookByMonth();
    }
    this.$commonApi.share();
    this.getOrderStatus();
  },
  methods: {
      getOrderStatus() {
      if(this.$base.getStorage("orderNum")&&this.$base.getStorage('isActivity')){
        var params = {
          orderNo: this.$base.getStorage("orderNum"),
          currentPageType:1
        };
        this.$api.getOrderStatus(params).then((res) => {
          this.$base.removeStorage("orderNum");
          this.$base.removeStorage("isActivity");
          if (res.status == 1) {
            Toast({
              message: res.message
            });
          }
        });
      }
    },
	  loadMore() {
		this.loading = true;
	if (this.pageNo < this.CountPage) {
          this.pageNo += 1;
          this.findReadBookByMonth();
        } else {
			this.loadText='没有更多了'
        	this.loading = false;
        }
		},
    eventChange() {
      this.isShowQcode = false;
    },
    insertPageAccessData() {
      var pageType = "";
      if (this.pageType == "bookMine") {
        pageType = "我的";
      } else if (this.pageType == "bookCharge") {
        pageType = "充值中心";
      } else  if (this.pageType == "bookCity") {
        pageType = "书城";
      }
      var params = {
        pageName: "最近阅读",
        pageRemark: "上级页面："+pageType,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    findReadBookByMonth() {
      var params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.isLoading=false;
      this.$api.findReadBookByMonth(params).then((res) => {
        if (res.status == 1) {
          this.CountPage = res.pages;
          if (this.pageNo == 1) {
            this.lastList = res.data;
            if (this.CountPage <= 1) {
              this.loadText = "没有更多了";
			
            } else {
              this.loadText = "加载中...";
            }
          } else {
            this.lastList = this.lastList.concat(res.data);
          }
          if (this.lastList.length == 0) {
            this.isEmpty = true;
          }else{
             this.isEmpty = false
          }
           this.isLoading=true;
          this.insertPageAccessData();
        }
      });
    },
    buyChange(data) {
      if (data) {
        if (data == 1) {
          this.purchaseWholeBook = 1;
          this.routeRead(this.item);
        } else if (data == 2) {
          this.showBuyMask = false;
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              bookId: this.item.id,
              needCurrency: this.countCurrency,
              pageType: "bookRead",
            },
          });
        }
      } else {
        this.showBuyMask = false;
      }
    },
    routeRead(item) {
      this.item = item;
      var params = {
        bookId: item.id,
        chapterId: item.chapterId, //章节排序order
        chapterorder: item.chapterOrders, //翻页标示 0:获取当前章节内容 1: 前一章 2：后一章,4从目录进入阅读器,3购买章节
        order: 0,
        booktype: "",
        isauto:0,
        rechargeOrderNum: "", //订单编号
        purchaseWholeBook: this.purchaseWholeBook,
        currentPageType:1
      };
      console.log(item);
      this.$api.findChapterContentByChapterId(params).then((res) => {
        if (res.status == 1) {
          this.showBuyMask = false;
          this.purchaseWholeBook = 0;
          this.$router.push({
            path: "/pages/bookRead/index",
            query: {
              bookid: item.id,
              pageType: "bookLastRead",
            },
          });
        } else if (res.status == 3) {
          this.showBuyMask = true;
          this.countCurrency = res.data.wholeBookCurrency;
          this.userCurrency = res.data.accountCurrency;
        } else if (res.status == 100 || res.status == 200||res.status==4) {
          if (res.data) {
            if(res.status==100&&res.data.priceType==3){
              this.$router.push({
                path: "/pages/bookCharge/index",
                query: {
                  bookId:item.id,
                  chapterId: res.data.id,
                  needCurrency: res.data.chapterPrice,
                  pageType: "bookRead",
                  priceType:res.data.priceType
                },
              });
              }else{
                this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId:item.id,
                  pageType: "bookLastRead",
                },
              });
              } 
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.content-box {
  padding-top: calc(44px + env(safe-area-inset-top));
}
.no-log {
  width: 100%;
  margin-top: 100px;
}

.empty-img {
  width: 128px;
  height: 128px;
  display: block;
  margin: 0 auto;
}

.no-log span {
  font-size: 12px;
  color: #333333;
  display: block;
  text-align: center;
  margin-top: 12px;
}

.content {
  padding: 0px 16px;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}

.list-item {
  display: flex;
  margin-top: 24px;
}

.cover-book {
  width: 75px;
  height: 100px;
  margin-right: 12px;
  border-radius: 8px;
}

.list-item span {
  display: block;
    line-height: 17px;
}

.list-item  .book-name {
  font-size: 16px;
  line-height: 22px;
  color: #5f5c5a;
    width: 100%;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.book-author {
  font-size: 12px;
  color: #706d71;
  margin-top: 8px;
  margin-bottom: 8px;
}

.list-item  .book-order {
  font-size: 12px;
  color: #706d71;
  margin-bottom: 11px;
   width: 100%;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.book-time {
  font-size: 12px;
  color: #999999;
}

.load-more {
  text-align: center;
    font-size: 12px;
color: #AAAAAA;
   padding: 16px 0px;
}

</style>



// WEBPACK FOOTER //
// src/view/bookLastRead/index.vue